import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

const FAQ = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate('/');
  };

  return (
    <div>
      {/* Navigation */}
      <nav className="nav">
        <div className="nav-container">
          <div className="logo" onClick={goBack}> GezinsScan</div>
          
          <div className="nav-links">
            <span className="nav-brand">by <strong>PABB</strong></span>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <section className="section" style={{paddingTop: '120px'}}>
        <div className="container">
          <div style={{maxWidth: '800px', margin: '0 auto'}}>
            
            {/* Header */}
            <div style={{textAlign: 'center', marginBottom: '3rem'}}>
              <h1 className="hero-title" style={{fontSize: '2.5rem', marginBottom: '1rem'}}>
                Veelgestelde Vragen
              </h1>
              <p className="hero-subtitle" style={{fontSize: '1.2rem', color: '#64748b'}}>
                Antwoorden op de meest gestelde vragen over de GezinsScanScan
              </p>
            </div>

            {/* Privacy & Anonimiteit */}
            <div className="benefit-card" style={{marginBottom: '2rem', borderLeft: '4px solid #10b981'}}>
              <h2 className="card-title">Privacy & Anonimiteit</h2>
              
              <h3 style={{color: '#1e3a8a', marginBottom: '0.5rem'}}>Q: Kan de therapeut zien wat ik heb geantwoord?</h3>
              <p style={{color: '#64748b', marginBottom: '1.5rem'}}>
                <strong>A:</strong> Ja, hierdoor kan de therapeut de verschillen tussen jou en je partner in kaart brengen. 
              </p>

                            <h3 style={{color: '#1e3a8a', marginBottom: '0.5rem'}}>Q: Worden mijn antwoorden opgeslagen?</h3>
              <p style={{color: '#64748b'}}>
                <strong>A:</strong> Ja, dit is nodig om teamscores te berekenen en rapporten te genereren.
              </p>
            </div>

            {/* Technische Vragen */}
            <div className="benefit-card" style={{marginBottom: '2rem', borderLeft: '4px solid #3b82f6'}}>
              <h2 className="card-title">Technische Vragen</h2>
              
              <h3 style={{color: '#1e3a8a', marginBottom: '0.5rem'}}>Q: Ik heb geen uitnodiging ontvangen, wat nu?</h3>
              <div style={{color: '#64748b', marginBottom: '1.5rem'}}>
                <strong>A:</strong>
                <ol style={{marginTop: '0.5rem', paddingLeft: '1.5rem'}}>
                  <li>Check je spam/junk folder</li>
                  <li>Controleer of je email correct is opgegeven bij je therapeut</li>
                  <li>Vraag je therapeut om de uitnodiging opnieuw te versturen</li>
                  </ol>
              </div>

              <h3 style={{color: '#1e3a8a', marginBottom: '0.5rem'}}>Q: Mijn quiz-link werkt niet, wat moet ik doen?</h3>
              <div style={{color: '#64748b', marginBottom: '1.5rem'}}>
                <strong>A:</strong>
                <ol style={{marginTop: '0.5rem', paddingLeft: '1.5rem'}}>
                  <li>Controleer of je de juiste link hebt gebruikt uit de email</li>
                  <li>Zorg dat je een moderne browser gebruikt</li>
                  <li>Probeer een andere browser of incognito modus</li>
                  <li>Contact je therapeut voor een nieuwe uitnodiging</li>
                </ol>
              </div>

              <h3 style={{color: '#1e3a8a', marginBottom: '0.5rem'}}>Q: Kan ik de quiz pauzeren en later afmaken?</h3>
              <p style={{color: '#64748b', marginBottom: '1.5rem'}}>
                <strong>A:</strong> Nee, de quiz moet in één keer worden afgemaakt. Reserveer 15 minuten ononderbroken tijd.
              </p>

              <h3 style={{color: '#1e3a8a', marginBottom: '0.5rem'}}>Q: Ik heb per ongeluk op "voltooien" geklikt, kan ik terug?</h3>
              <p style={{color: '#64748b'}}>
                <strong>A:</strong> Nee, als de quiz is voltooid kun je niet meer terug. Elke code werkt maar één keer. 
                Neem contact op met je therapeut.
              </p>
            </div>

            {/* Pakketten & Account */}
            <div className="benefit-card" style={{marginBottom: '2rem', borderLeft: '4px solid #f59e0b'}}>
              <h2 className="card-title">Scans & Account</h2>
              
              <h3 style={{color: '#1e3a8a', marginBottom: '0.5rem'}}>Q: Hoe kan ik een scan kopen?</h3>
              <p style={{color: '#64748b', marginBottom: '1.5rem'}}>
                <strong>A:</strong> Momenteel worden scans handmatig toegekend. Stuur een email naar 
                diederik@tractum.nl met je vraag.
              </p>

              <h3 style={{color: '#1e3a8a', marginBottom: '0.5rem'}}>Q: Wat kost een GezinsScan pakket?</h3>
              <p style={{color: '#64748b', marginBottom: '1.5rem'}}>
                <strong>A:</strong> Neem contact op met diederik@tractum.nl voor actuele prijsinformatie en pakketopties.
              </p>

              <h3 style={{color: '#1e3a8a', marginBottom: '0.5rem'}}>Q: Kan ik meerdere gezinnen scannen?</h3>
              <p style={{color: '#64748b', marginBottom: '1.5rem'}}>
                <strong>A:</strong> Ja, maar elk gezin heeft een eigen scan nodig.
              </p>

              <h3 style={{color: '#1e3a8a', marginBottom: '0.5rem'}}>Q: Hoe lang is een scan geldig?</h3>
              <p style={{color: '#64748b'}}>
                <strong>A:</strong> Dit wordt bepaald bij activatie. Standaard hebben pakketten een geldigheid van 1 jaar.
              </p>
            </div>

            {/* Resultaten & Rapporten */}
            <div className="benefit-card" style={{marginBottom: '2rem', borderLeft: '4px solid #7c3aed'}}>
              <h2 className="card-title">Resultaten & Rapporten</h2>
              
              <h3 style={{color: '#1e3a8a', marginBottom: '0.5rem'}}>Q: Wanneer zijn de resultaten beschikbaar?</h3>
              <p style={{color: '#64748b', marginBottom: '1.5rem'}}>
                <strong>A:</strong> Zodra alle gezinsleden de quiz hebben ingevuld, zijn de resultaten direct beschikbaar voor de therapeut.
              </p>

              <h3 style={{color: '#1e3a8a', marginBottom: '0.5rem'}}>Q: Kan ik mijn eigen individuele resultaten zien?</h3>
              <p style={{color: '#64748b', marginBottom: '1.5rem'}}>
                <strong>A:</strong> Nee, alleen therapeuten hebben toegang tot de resultaten. 
                Je therapeut kan het rapport wel met jou delen.
              </p>

              <h3 style={{color: '#1e3a8a', marginBottom: '0.5rem'}}>Q: Hoe betrouwbaar zijn de resultaten?</h3>
              <p style={{color: '#64748b'}}>
                <strong>A:</strong> De GezinsScan is gebaseerd op de wetenschappelijk onderbouwde Lencioni methodiek en aangepast in samenwerking met gezinstherapeuten.
                Voor betrouwbare resultaten zijn minimaal 3-4 deelnemers nodig.
              </p>
            </div>

            {/* Problemen Oplossen */}
            <div className="benefit-card" style={{marginBottom: '2rem', borderLeft: '4px solid #ef4444'}}>
              <h2 className="card-title">Problemen Oplossen</h2>
              
              <h3 style={{color: '#1e3a8a', marginBottom: '0.5rem'}}>Q: De website laadt niet, wat nu?</h3>
              <div style={{color: '#64748b', marginBottom: '1.5rem'}}>
                <strong>A:</strong>
                <ol style={{marginTop: '0.5rem', paddingLeft: '1.5rem'}}>
                  <li>Controleer je internetverbinding</li>
                  <li>Probeer een andere browser</li>
                  <li>Wis je browser cache</li>
                  <li>Probeer later opnieuw</li>
                  <li>Contact: diederik@tractum.nl</li>
                </ol>
              </div>

              <h3 style={{color: '#1e3a8a', marginBottom: '0.5rem'}}>Q: Ik krijg een foutmelding, wat betekent dat?</h3>
              <p style={{color: '#64748b'}}>
                <strong>A:</strong> Screenshot de foutmelding en stuur deze naar diederik@tractum.nl voor snelle hulp.
              </p>
            </div>

            {/* Contact & Ondersteuning */}
            <div className="benefit-card" style={{marginBottom: '2rem', borderLeft: '4px solid #dc2626'}}>
              <h2 className="card-title">Contact & Ondersteuning</h2>
              
              <div style={{background: '#f8fafc', padding: '1.5rem', borderRadius: '8px', marginBottom: '1.5rem'}}>
                <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Voor Vragen of Problemen</h3>
                <p style={{color: '#64748b', marginBottom: '1rem'}}>
                  <strong>Email:</strong> diederik@tractum.nl<br/>
                  <strong>Website:</strong> <a href="https://tractum.nl" style={{color: '#3b82f6'}}>https://tractum.nl</a><br/>
                  <strong>TeamScan:</strong> <a href="https://gezinsscan.pabb.nl" style={{color: '#3b82f6'}}>https://gezinsscan.pabb.nl</a>
                </p>
                
                <h4 style={{color: '#059669', marginBottom: '0.5rem'}}>Responstijden</h4>
                <ul style={{color: '#64748b', lineHeight: '1.8', margin: '0'}}>
                  <li><strong>Technische problemen:</strong> Binnen 24 uur</li>
                  <li><strong>Scan aanvragen:</strong> 1-2 werkdagen</li>
                  <li><strong>Algemene vragen:</strong> Binnen 48 uur</li>
                </ul>
              </div>

              <h3 style={{color: '#1e3a8a', marginBottom: '1rem'}}>Tips voor Snelle Hulp</h3>
              <ol style={{color: '#64748b', lineHeight: '1.8'}}>
                <li><strong>Beschrijf het probleem</strong> zo specifiek mogelijk</li>
                <li><strong>Vermeld je browser</strong> en versie indien relevant</li>
                <li><strong>Stuur screenshots</strong> mee van foutmeldingen</li>
                              </ol>
            </div>

            {/* Update Info */}
            <div style={{textAlign: 'center', padding: '2rem', background: '#f8fafc', borderRadius: '8px', marginBottom: '2rem'}}>
              <p style={{color: '#64748b', margin: '0', fontStyle: 'italic'}}>
                Deze handleiding wordt regelmatig bijgewerkt. Laatste update: Januari 2026
              </p>
            </div>

            {/* Disclaimer */}
            <div style={{background: '#f1f5f9', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem'}}>
              <p style={{color: '#475569', margin: '0', fontSize: '0.9rem', fontStyle: 'italic'}}>
                <strong>Disclaimer:</strong> De GezinsScan is gebaseerd op het model "De 5 frustraties van teamwork" van Patrick Lencioni. 
                Dit product is onafhankelijk ontwikkeld door PABB VOF en staat los van Patrick Lencioni en The Table Group. 
                Alle rechten op het originele model en de theorie blijven bij Patrick Lencioni.
              </p>
            </div>

            {/* Navigation */}
            <div style={{textAlign: 'center', marginTop: '3rem'}}>
              <button 
                className="secondary-button" 
                onClick={goBack}
                style={{marginRight: '1rem'}}
              >
                ← Terug naar TeamScan
              </button>
              <button 
                className="cta-button" 
                onClick={() => navigate('/handleiding-therapeut')}
              >
                Handleiding Therapeut →
              </button>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;